// This file is automatically generated by the build process.
// Do not edit this file manually.
// Instead, update the version in package.json and run the build script.
// The version is used to ensure compatibility between the SDK and the server.
export const CURRENT_VERSION = '1.1.202';
//# sourceMappingURL=currentVersion.js.map